import TrailerHistoryTab from './TrailerHistoryTab';

const TrailerHistoryPage = () => {
  return (
    <div className="p-5">
      <h1 className="text-2xl font-bold mb-4">Trailer History</h1>
      <TrailerHistoryTab />
    </div>
  );
};

export default TrailerHistoryPage;
